// extracted by mini-css-extract-plugin
export default {"root":"BuyDisableAds__root--3yU55","content":"BuyDisableAds__content--3PTgR"};